import React, { Component } from 'react';
import {NavLink, Link} from "react-router-dom";
import logodashheader  from '../Assets/logo-dash-header.png';
import FeedBackImg from '../Assets/ratings-review.png';
import { documentAllowedRepo, documentAllowed, name, platform, ApiEndpoint } from "../Constant";
import Footer from "../Components/footer";
import  Header  from "../Components/header";
import SideBar from "../Components/sidebar";
import Button from "../Components/button";
import { Input, Textarea, Select, File } from "../Components/input";
import Form from "../Components/form";
import { clearSession, RedirectNotLogin, getSession, UpdateState, getState, handleSubmit, BreedForm, AlertMessage, AlertMessageOut, serializeArray } from "../Components/function";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { DateTime } from "../Components/function";
import * as axios from 'axios';


// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load();

export const FingerPrint = async (type = 'visitor') => {
// Get the visitor identifier when you need it.
const fp = await fpPromise;
const result = await fp.get();

// This is the visitor identifier:
if(type === 'visitor'){
 return result.visitorId;
}
else{
  //return result.visitorId;
}
}

class Resubmit extends Component{

  constructor(props){
    super(props);
    
    this.state = {
      userID : '',
      data: [],
      scriptID: '',
      file: '',
      message: '',
      retry_times: 0,
    }
    }
    
    componentDidMount(){
      RedirectNotLogin();
      this.loadDataFromServer();
    }

    componentDidUpdate() {
      RedirectNotLogin();
    }
 
    loadDataFromServer = async () => {
        
      UpdateState(this, 'loading', '1');

      let DeviceSid = await FingerPrint();

      let header = {
          headers : {
              'Accept': 'application/json',
              'Content-Type': "application/x-www-form-urlencoded",
              'Authorization': "Bearer " + getSession('token') + ", Session " + DeviceSid + ", Platform "+ platform,
              'My-Custom-Header': name,
              'User-Agent': name+ " Bot",
             }
       };

       let datas = new URLSearchParams({
          command: 'fetch',
          cmd: 'fetchcontact',
          user_id: getSession('userID'),
      }).toString();
       
         axios.get(ApiEndpoint+"/fetchResult?"+datas, header)
         .then(response => {
         
          UpdateState(this, 'loading', '0');


          if(response.data.retry == true){
             let retryTimes = getState(this, 'retry_times') >= 0 && getState(this, 'retry_times') != '' ? getState(this, 'retry_times') : ''; 
             if(retryTimes != ''){
             if(getState(this, 'retry_times') < 15){
             setTimeout(function(){
             UpdateState(this, 'retry_times', getState(this, 'retry_times') + 1);
             this.loadDataFromServer();
              }, 4000);
             }
             }
           }

    
        if(response.data.error == false && response.data.error != true){
        //alert(JSON.stringify(response.data.data));
        UpdateState(this, 'data', response.data.data != "" ? response.data.data : []);
        UpdateState(this, 'message', '');
        UpdateState(this, 'loading', '0');

        }
        else if(response.data.error != false){
          AlertMessage(this, response.data.error, 'error');

          if(response.data.logout == true && response.data.token == false){
            setTimeout(function(){
            clearSession();
            window.location.href = "/login";
            }, 4000);
            }
        }
        else{
          AlertMessage(this, "Something went wrong, try again or try to reload the page!", 'error');
        }
      }).catch(err => {
          AlertMessage(this, "Something went wrong, try again or try to reload the page!\n\r"+err, 'error');
          this.loadDataFromServer();
      });
    }

  render(){
    return (
        <div className="App AppWrap">
    
    <Header self={this}/>
    <SideBar self={this}/>

    <div className="App iBG dash-dash">
    <div className="containers">
  
  <div className="card-lt-wrap">
    <div className="card-lt">
    <div className="card-form-lts">
       
        {getState(this, 'loading') == '1' ?
   (<div className="table-loader">
  <div className="overlay">
    <div className="overlay__inner">
        <div className="overlay__content"><span className="spinner"></span></div>
    </div>
</div>
</div>) : ''}
      
        <Form route="submit">
     
     {AlertMessageOut(this)}

     <div className="grey-left">
<h5>Reference: Mention "<b>{getState(this, 'data')?.userID != "" ? (getState(this, 'data')?.userID) : getSession('userID') }</b>" while contacting us</h5>
</div>
<br/>
     <div className="grey-left">
<h5>Phone: {getState(this, 'data')?.phone != "" ? (<a href={"tel:"+getState(this, 'data')?.phone}>{getState(this, 'data')?.phone}</a>) : '' }</h5>
</div>
<br/>
     <div className="grey-left">
<h5>Email: {getState(this, 'data')?.email != "" ? (<a href={"mailto:"+getState(this, 'data')?.email}>{getState(this, 'data')?.email}</a>) : '' }</h5>
</div>
<br/>
<div className="grey-left">
<h5>Address: {getState(this, 'data')?.address}</h5>
</div>

      </Form>
      </div>

      </div>
        

        <Footer classX="dash-footer"/>

    </div>
    
    </div>

    </div>

    </div>
    );
}

}

export default Resubmit;